import {useState, useEffect, useCallback} from 'react';

export default function useLocalState<T>(
    key: string,
    defaultValue: T
): [T, (value: T | ((prevValue: T) => T)) => void] {
    const [state, setState] = useState<T>(() => {
        const storedValue = localStorage.getItem(key);

        return storedValue ? JSON.parse(storedValue) : defaultValue;
    });

    const setValue = useCallback(
        (value: T | ((prevValue: T) => T)) => {
            setState(prevState => {
                const newValue =
                    typeof value === 'function'
                        ? (value as (prevValue: T) => T)(prevState)
                        : value;

                localStorage.setItem(key, JSON.stringify(newValue));
                return newValue;
            });
        },
        [key]
    );

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);

    return [state, setValue];
}
